module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/images/flags-9c74e172f87984c48ddf5c8108cabe67.png";